import { type MCPServerInfo } from '../../types';

const DropboxServer: MCPServerInfo = {
  serverId: 'DROPBOX',
  name: 'Dropbox',
  slug: 'dropbox',
  description:
    'Dropbox MCP server for managing files, folders, sharing, team members, and groups in a Dropbox Business workspace.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'https://github.com/natomalabs/dbx-admin-mcp',
    commitSha: '8b5eaff',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['dropboxSPublicWorkspaceApiKey'],
    properties: {
      dropboxSPublicWorkspaceApiKey: {
        type: 'string',
        description: 'Dropbox API key',
        sensitive: true
      }
    }
  },
  deprecated: true
};

export default DropboxServer;
